import { DragAndDropPinSettings } from '@lessonup/pins-shared';
import { styled } from '@lessonup/ui-components';
import React from 'react';
import { PinBackground } from '../components/PinBackground';

export interface DragAndDropPinProps {
  pinSettings: DragAndDropPinSettings;
  isThumb?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export const DragAndDropPinComponent: React.FC<DragAndDropPinProps> = ({
  pinSettings,
  isThumb,
  children,
  className,
}) => {
  return (
    <DragAndDropWrapper className={className}>
      <PinBackground pinType="DRAG_AND_DROP" settings={pinSettings} isThumb={isThumb} />
      {children}
    </DragAndDropWrapper>
  );
};

const DragAndDropWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;
